import { forwardRef } from 'react'
import { ethAddressValidator } from '../../hooks/useValidation'
import { TextInput, TextInputHandle, TextInputProps } from '../TextInput/TextInput'

type EthereumAddressInputProps = { ensSupport?: boolean } & TextInputProps

export const EthereumAddressInput = forwardRef<TextInputHandle, EthereumAddressInputProps>(({
  ensSupport = false,
  ...textInputProps
}, ref) => (
  <TextInput
    ref={ref}
    placeholder="0x1a2b3c4d5e6f..."
    validators={[ethAddressValidator(ensSupport)]}
    autoComplete="off"
    spellCheck="false"
    {...textInputProps}
  />
))
